import { useParams, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import server from '../../../api/server'
import { MdArrowBack, MdDownload, MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'
import { ChevronRight, ChevronDown, Download, Copy, Check } from 'lucide-react'
import { MdExpandLess } from 'react-icons/md'
import { downloadIndividualReportAsExcel } from '../../../utils/excelUtils'
import "../../../dashboard-components/loader.css"
import CallDetails from '../calls/CallDetails'
import { FaTimes } from 'react-icons/fa'
import { useToast } from '../../../context/ToastContext'
import ConversationRecords from '../calls/ConversationRecords'

const IndividualReport = ({serviceID, clientID, reportIdProp}) => {
  const {showToast} = useToast()
    const {reportId} = useParams()
    const [service_id, setService_id] = useState(null)
    const [client_id, setClient_id] = useState(null)
    const [report_id, setReport_id] = useState(null)
    const [email, setEmail] = useState(null)
    const [loading, setLoading] = useState(false)
    const [reportData, setReportData] = useState({})
    const [metadata, setMetadata] = useState(null)
    const [activeOverallTab, setActiveOverallTab] = useState('skill_level')
    const [activeConcernsQueriesTab, setActiveConcernsQueriesTab] = useState('concerns')
    const [selectedModule, setSelectedModule] = useState(null);
    const [openSections, setOpenSections] = useState({
        ...Object.keys(reportData?.parameters || {}).reduce((acc, key) => {
            acc[`param_${key}`] = false;
            return acc;
        }, {}),
    });
    const [showGenerateTrainingSessionModal, setShowGenerateTrainingSessionModal] = useState(false);
    const [showConversationModal, setShowConversationModal] = useState(false);
    const [conversationId, setConversationId] = useState(null);
    const [segmentId, setSegmentId] = useState(null);
    const navigate = useNavigate()
    const [copyClicked, setCopyClicked] = useState(false);
    const [showConversationRecordsModal, setShowConversationRecordsModal] = useState(false);
    const [recordsSegment, setRecordsSegment] = useState(null);

    const handleClose = () => {
      setConversationId(null);
      setSegmentId(null);
      setShowConversationModal(false);
      setSelectedModule(null);
    }

    const toggleSection = (section) => {
        setOpenSections(prev => ({ ...prev, [section]: !prev[section] }));
    };
    const handleDownload = async () => {
        try {
            const filename = `agent-feedback-report-${metadata?.report_id || 'report'}-${new Date().toISOString().split('T')[0]}.xlsx`;
            downloadIndividualReportAsExcel(filename, reportData, metadata);
        } catch (error) {
            console.error('Error downloading Excel:', error);
            alert('Error generating Excel. Please try again.');
        }
    }
    function getCookie(name) {
      function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
      var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
      return match ? match[1] : null;
  }
    
    useEffect(() => {
        if(serviceID){
            setService_id(serviceID)
        }
        if(clientID){
            setClient_id(clientID)
        }
        if(reportId){
            setReport_id(reportId)
        }
        if(reportIdProp){
          setReport_id(reportIdProp)
        }
        const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
        if (user) {
          setEmail(user.email);
        }
    }, [serviceID, clientID, reportId, reportIdProp])

    useEffect(() => {
        if(service_id && client_id && report_id){
            getReportData()
        }
    }, [service_id, client_id, report_id])

    const getReportData = async () => {
      try {
        setLoading(true);
        let res = await server.getDetailedReportData(client_id, service_id, email, report_id, 'agent-feedback', 'reports')
        if(res.status === 200){
          let resp = await res.json()
          setReportData(resp.data)
          setMetadata(resp.metadata)
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
    const handleGoBack = () => {
        navigate(-1)
    }
    
    // Helper function to get status styling
    const getStatusStyle = (status) => {
      const normalizedStatus = status?.toLowerCase();
      switch (normalizedStatus) {
        case 'received':
          return {
            backgroundColor: '#f3f4f6',
            color: '#6b7280',
            text: 'Queued'
          };
        case 'processing':
          return {
            backgroundColor: '#e0e7ff',
            color: '#4338ca',
            text: 'Processing'
          };
        case 'success':
          return {
            backgroundColor: '#dcfce7',
            color: '#166534',
            text: 'Success'
          };
        case 'failed':
          return {
            backgroundColor: '#fecaca',
            color: '#dc2626',
            text: 'Failed'
          };
        default:
          return {
            backgroundColor: '#f3f4f6',
            color: '#6b7280',
            text: status || 'Unknown'
          };
      }
    };

    const getScoreBar = (score) => {
        let color = 'bg-green-500';
        let width = `${score}%`;
        
        
        
        return (
          <div className="w-16 bg-gray-200 rounded h-2">
            <div className={`h-2 rounded ${color}`} style={{ width }}></div>
          </div>
        );
      };

      const renderExplanations = (data, module, type=null) => {
        let source_id_map = {}
        let currentIndex = 1;

        for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < data[i].sources.length; j++) {
              if(data[i].sources[j]?.conversation_id && data[i].sources[j]?.segment_id){
                let id = data[i].sources[j]?.conversation_id +'_'+ data[i].sources[j]?.segment_id;
                if (!source_id_map[id]) {
                  source_id_map[id] = currentIndex++;
                }
              }else{
                source_id_map[data[i].sources[j]?.segment_id] = currentIndex++;
              }
            }
        }
        const formattedTime = (time) => {
          if(!time || time === ''){
            return ''
        }
            return new Date(time * 1000).toLocaleString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit'
            });
          };
          const handleSourceClick = (source) => {
            setShowConversationModal(true);
            setConversationId(source.conversation_id);
            setSegmentId(source);
            setSelectedModule(module);
          }
          return (
            <>
            {
              type && type === 'bulletpoints' ? <ul style={{listStyleType: "disc", paddingLeft: "20px", fontSize: "13px"}}>
                {data && data.map((item, idx) => {
                  let title = item.title || null;
                  return (
                    <span key={idx}>
                    {title && <div className='font-semibold' style={{fontSize: "14px"}}>{title}</div>}
                    <li key={idx} style={{fontSize: "13px", marginBottom: "10px"}}>{item.text}
                    <span style={{wordBreak: "break-all"}}>{item.sources.map((source, idx) => (
                  <span key={idx} onClick={() => handleSourceClick(source)} className="bg-gray-100 p-1 mx-1 rounded text-gray-600 text-xs cursor-pointer">{source_id_map[source.conversation_id +'_'+ source.segment_id] || formattedTime(source.start_timestamp) || source_id_map[source.segment_id]}</span>
                ))}</span>
                    </li>
                    </span>
                  )
                })}
              </ul>
              :
              <>
              {data && data.map((item, idx) => {
                let title = item.title || null;
              return (
                <span key={idx} style={{marginBottom: "10px"}}>
                    {title && <div className='font-semibold' style={{fontSize: "14px"}}>{title}</div>}
                  <span style={{fontSize: "13px"}}>{item.text}
                  <span style={{wordBreak: "break-all"}}>{item.sources.map((source, idx) => (
                  <span key={idx} onClick={() => handleSourceClick(source)} className="bg-gray-100 p-1 mx-1 rounded text-gray-600 text-xs cursor-pointer">{source_id_map[source.conversation_id +'_'+ source.segment_id] || formattedTime(source.start_timestamp) || source_id_map[source.segment_id]}</span>
                ))}</span>
                </span>
              </span>
            )
          })}</>
            }
          </>
          )
      }
      const renderSubparameters = (subparameters, parentKey) => (
        <div style={{ padding: "0 20px" }}>
          {subparameters.map((subparam, idx) => {
            const subKey = `${parentKey}-sub-${idx}`;
            return (
              <div
                key={subKey}
                style={{
                  margin: "5px 0",
                  borderRadius: "6px",
                  background: "rgba(255, 255, 255, 0.28)"
                }} className="border"
              >
                <div
                  onClick={() => toggleSection(`${parentKey}-sub-${idx}`)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "5px",
                    alignItems: "center",
                    borderRadius: "6px",
                    background: openSections[`${parentKey}-sub-${idx}`] ? "white":"",
                    height: "60px",
                    margin: "auto"
                  }}
                >
                  <span style={{ color: "black", fontSize: "14px", display: "flex", alignItems: "center" }}>
                    {(subparam.output?.explanation || (subparam.output?.explanation_with_source && subparam.output?.explanation_with_source.length>0)) && <> {openSections[`${parentKey}-sub-${idx}`] ? <span style={{marginRight: "5px"}}><MdExpandLess/></span> : <span style={{marginRight: "5px"}}><ChevronRight style={{height: "15px", width: "15px"}}/></span>} </>} 
                    {subparam.name}</span>
                  <span
                    style={{
                      lineHeight: subparam.output?.ans ? "1rem" : "",
                      padding: subparam.output?.ans ? "0.25rem 0.75rem" : "",
                      textAlign: "center",
                      borderRadius: subparam.output?.ans ? "6px" : "",
                      fontSize: "13px"
                    }} className="bg-indigo-50 text-indigo-600"
                  >
                    {(subparam.output?.ans?.length>25 && !openSections[`${parentKey}-sub-${idx}`]) ? subparam.output.ans.substr(0, 25)+"..." : subparam.output.ans}
                  </span>
                </div>
                {openSections[`${parentKey}-sub-${idx}`] && <hr style={{margin: "0"}}/>}
                {openSections[`${parentKey}-sub-${idx}`] && (
                  <div style={{ padding: "5px 10px 5px 25px", overflowY: "scroll" }}>
                    {subparam.output.explanation_with_source ? renderExplanations(subparam.output.explanation_with_source, 'Agent Feedback', 'bulletpoints') : (
                      <>
                    {subparam.output.explanation && (
                      Array.isArray(subparam.output.explanation) ? (
                        <ul style={{ fontSize: "13px", paddingLeft: "10px", listStyle: "disc" }}>
                          {subparam.output.explanation.map((item, index) => (
                            <li key={index} style={{ fontSize: "13px" }}>{item}</li>
                          ))}
                        </ul>
                      ) : (
                        <div style={{ fontSize: "13px" }}>{subparam.output.explanation}</div>
                      )
                    )}
                    </>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      );
      const create_date_range = (start_time, end_time) => {
        let start_date = new Date(start_time * 1000);
        let end_date = new Date(end_time * 1000);
        return `${start_date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })} - ${end_date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`;
      }
      const handleGotoTrainingSessionId = () => {
        navigate(`/${clientID}/${serviceID}/agent-feedback/training/${metadata?.training_session_id}`)
      }
      const handleGenerateTrainingSession = () => {
        setShowGenerateTrainingSessionModal(true)
      }
      const generateTrainingSession = async () => {
        try {
          let obj = {
            client_id: clientID,
            service_id: serviceID,
            report_id: metadata?.report_id,
            email: email,
            menu: 'agent-feedback',
            submenu: 'training'
          }
          let res = await server.generateTrainingSession(obj)
          if(res.status === 200){
            showToast("Training session generation in progress. We will notify you once completed.", "success");
            getReportData()
            setShowGenerateTrainingSessionModal(false);
          }else{
            showToast("Error generating training session. Please try again.", "error");
          }
        } catch (error) {
          showToast("Error generating training session. Please try again.", "error");
        }
      }

    /* --------------------------------------------------
       Expand-All Helper (for PDF generation)
    --------------------------------------------------*/
    // Recursively build a map of all parameter & sub-parameter keys and set them to true
    const expandAllParameterSections = () => {
      const stateObj = {};

      const traverseSubs = (subs = [], parentKey) => {
        subs.forEach((sub, idx) => {
          const key = `${parentKey}-sub-${idx}`;
          stateObj[key] = true;
          if (Array.isArray(sub.subparameters) && sub.subparameters.length > 0) {
            traverseSubs(sub.subparameters, key);
          }
        });
      };

      Object.entries(reportData?.parameters || {}).forEach(([key, value]) => {
        const parentKey = `param_${key}`;
        stateObj[parentKey] = true;
        if (Array.isArray(value.subparameters) && value.subparameters.length > 0) {
          traverseSubs(value.subparameters, parentKey);
        }
      });

      if (Object.keys(stateObj).length > 0) {
        setOpenSections(prev => ({ ...prev, ...stateObj }));
      }
    };

    // Listen for custom event fired from pdfUtils to expand everything
    useEffect(() => {
      const handleExpandEvt = () => {
        expandAllParameterSections();
      };
      window.addEventListener('expandAllParameters', handleExpandEvt);
      return () => window.removeEventListener('expandAllParameters', handleExpandEvt);
    }, [reportData]);

  const formatDateForFilters = (epochSec) => {
    try {
      return new Date(epochSec * 1000).toISOString().slice(0, 10);
    } catch (e) { return '' }
  }
  const getEmployeeFromRow = (rowObj) => {
    if (!rowObj || typeof rowObj !== 'object') return null;
    const keys = Object.keys(rowObj);
    // Prefer keys that look like name/employee
    const nameKey = keys.find(k => String(k).toLowerCase().includes('name'))
                 || keys.find(k => String(k).toLowerCase().includes('employee'))
                 || keys[0];
    return rowObj[nameKey] ?? null;
  }
  const openRecordsForMetric = (metricKey, employeeOverride = null) => {
    const seg = { id: null, name: null, type: 'report_metric', filter_applied: {} };
    if (metricKey === 'fatal') {
      seg.id = 'fatal';
      seg.name = 'Yes';
      seg.filter_applied.fatal = 'Yes';
    } else if (metricKey === 'needs_review') {
      seg.id = 'needsReview';
      seg.name = 'Yes';
      seg.filter_applied.needsReview = 'Yes';
    }
    if (employeeOverride || metadata?.employee_id) {
      seg.filter_applied.employee = employeeOverride || metadata.employee_id;
    }
    if (metadata?.report_start_time && metadata?.report_end_time) {
      seg.filter_applied.time = 'Custom Range';
      seg.filter_applied.customStart = formatDateForFilters(metadata.report_start_time);
      seg.filter_applied.customEnd = formatDateForFilters(metadata.report_end_time);
    }
    setRecordsSegment(seg);
    setShowConversationRecordsModal(true);
  }

  return (
    <div style={{ width: "100%", height: window.innerHeight - 66.5, overflowY: "auto" }} className="bg-gray-50 px-5 font-sans">
      {
        !loading ? (
          <>
          <div className={`flex justify-between`}>
            <button onClick={handleGoBack} style={{display: 'flex',alignItems: 'center',color: '#4b5563',cursor: 'pointer',border: 'none',background: 'none',padding: '8px',fontSize: '14px', cursor: 'pointer'}}>
              <MdArrowBack style={{ marginRight: '8px' }} />
              Back
            </button>
            <button onClick={handleDownload} style={{display: 'flex',alignItems: 'center',color: '#4b5563',cursor: 'pointer',border: 'none',background: 'none',padding: '8px',fontSize: '14px', cursor: 'pointer'}}>
              <Download style={{ marginRight: '8px' }} size={16}/>
              Download
            </button>
          </div>
          {
            !reportData ? (
              <>
              <div className="flex justify-center items-center" style={{ height: "100%", flexDirection: "column" }}>
                        <img src="/assets/paper.png" style={{height: "10vh"}} alt=""/>
                        <h2 style={{textAlign: "center", fontSize: "24px"}}>No Report Found.</h2>
                    </div>
              </>
            ) : (
              <div className="rounded-lg pb-5 space-y-4" id="individual-report-container">
                <div className="flex justify-between items-center border p-4 rounded-lg bg-white" style={{gap: "10px", marginBottom: "10px", flexWrap: "wrap"}}>
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Report ID</h2>
                        <p style={{fontSize: "15px", display: "flex", alignItems: "center"}}>{metadata?.report_id.length > 20 ? metadata?.report_id.slice(0, 20) + '...' : metadata?.report_id} 
                            {!copyClicked &&<Copy className='cursor-pointer ml-2 mr-2 text-xs h-4 w-4' onClick={() => {navigator.clipboard.writeText(metadata?.report_id); setCopyClicked(true); setTimeout(() => {setCopyClicked(false)}, 1000)}} />}
                            {copyClicked &&<Check className='cursor-pointer ml-2 mr-2 text-xs h-4 w-4' />}
                            </p>
                    </div>
                    {
                      metadata?.employee_id && (<div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                          <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Employee ID</h2>
                          <p style={{fontSize: "15px"}}>{metadata?.employee_id}</p>
                      </div>)
                    }
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Date Range</h2>
                        <p style={{fontSize: "15px"}}>{create_date_range(metadata?.report_start_time, metadata?.report_end_time)}</p>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Created At</h2>
                        <p style={{fontSize: "15px"}}>{new Date(metadata?.createdat*1000).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Created By</h2>
                        <p style={{fontSize: "15px"}}>{metadata?.created_by}</p>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                        <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Status</h2>
                        <span style={{
                            fontSize: "15px",
                            textTransform: "capitalize",
                            backgroundColor: getStatusStyle(metadata?.status).backgroundColor,
                            color: getStatusStyle(metadata?.status).color,
                            padding: '4px 8px',
                            borderRadius: '4px',
                            display: 'inline-block'
                        }}>
                            {getStatusStyle(metadata?.status).text}
                        </span>
                    </div>
                    {metadata?.employee_id && metadata?.status != 'processing' && metadata?.status != 'failed' && (
                      <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                          <h2 style={{fontSize: "13px", color: "darkslategrey", textTransform: "uppercase"}}>Training Session</h2>
                          <p style={{fontSize: "15px"}}>{metadata?.training_session_id ? 
                            <span onClick={()=>handleGotoTrainingSessionId()} style={{transition: "background 0.3s, color 0.3s, box-shadow 0.3s", border: "1px solid rgb(209 213 217)", width: "90px", fontSize: "12px", textAlign: "center", padding: "3px", borderRadius: "6px", cursor: "pointer", background: "white"}}>Visit Session</span> : 
                          <span onClick={()=>handleGenerateTrainingSession()} style={{transition: "background 0.3s, color 0.3s, box-shadow 0.3s", border: "1px solid rgb(209 213 217)", width: "90px", fontSize: "12px", textAlign: "center", padding: "3px", borderRadius: "6px", cursor: "pointer", background: "white"}}>Generate Session</span>}</p>
                      </div>
                    )}
                </div>
                {/* Overall Section */}
                <div className="rounded-lg bg-white p-4 rounded-lg border">
                    <h1 className="text-xl font-semibold text-gray-900 mb-2">Overall</h1>

                    {/* Tab Navigation */}
                    <div className="flex border-b mb-4">
                        {reportData?.overall?.skill_level && <button
                            onClick={() => setActiveOverallTab('skill_level')}
                            className={`px-4 py-2 text-sm rounded-t-lg`} style={{borderBottom: (activeOverallTab === 'skill_level') ? "3.5px solid rgb(111, 111, 254)" : "2px solid transparent", color: (activeOverallTab === 'skill_level') ? "rgb(111, 111, 254)": "black", fontSize: "15px"}}
                        >
                            Skill Level
                        </button>}
                        {reportData?.overall?.agent_level && <button
                            onClick={() => setActiveOverallTab('agent_level')}
                            className={`px-4 py-2 text-sm rounded-t-lg`} style={{borderBottom: (activeOverallTab === 'agent_level') ? "3.5px solid rgb(111, 111, 254)" : "2px solid transparent", color: (activeOverallTab === 'agent_level') ? "rgb(111, 111, 254)": "black", fontSize: "15px"}}
                        >
                            Agent Level
                        </button>}
                        {reportData?.overall?.previous_period_comparison && <button
                            onClick={() => setActiveOverallTab('previous_period_comparison')}
                            className={`px-4 py-2 text-sm rounded-t-lg`} style={{borderBottom: (activeOverallTab === 'previous_period_comparison') ? "3.5px solid rgb(111, 111, 254)" : "2px solid transparent", color: (activeOverallTab === 'previous_period_comparison') ? "rgb(111, 111, 254)": "black", fontSize: "15px"}}
                        >
                            Previous Period Comparison
                        </button>}
                    </div>

                    {/* Tab Content */}
                    <div className="">
                        {activeOverallTab === 'skill_level' && (
                            <div className="flex gap-3">
                                <div className="border rounded-lg w-1/2">
                                    <div className="text-md p-3 bg-green-50 text-green-900 rounded-t-lg">Key Positive Points</div>
                                    <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                        {reportData?.overall?.skill_level?.positive_points && renderExplanations(reportData.overall.skill_level.positive_points, 'Agent Feedback', 'bulletpoints')}
                                    </div>
                                </div>
                                
                                <div className="border rounded-lg w-1/2">
                                    <div className="text-md p-3 bg-orange-50 text-orange-900 rounded-t-lg">Key Improvements</div>
                                    <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                        {reportData?.overall?.skill_level?.negative_points && renderExplanations(reportData.overall.skill_level.negative_points, 'Agent Feedback', 'bulletpoints')}
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeOverallTab === 'agent_level' && (
                            <div className="flex gap-3">
                              <div className="border rounded-lg w-1/2">
                                  <div className="text-md p-3 bg-green-50 text-green-900 rounded-t-lg">Key Positive Points</div>
                                  <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                      {reportData?.overall?.agent_level?.positive_points && renderExplanations(reportData.overall.agent_level.positive_points, 'Agent Feedback', 'bulletpoints')}
                                  </div>
                              </div>
                              
                              <div className="border rounded-lg w-1/2">
                                  <div className="text-md p-3 bg-orange-50 text-orange-900 rounded-t-lg">Key Improvements</div>
                                  <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                      {reportData?.overall?.agent_level?.negative_points && renderExplanations(reportData.overall.agent_level.negative_points, 'Agent Feedback', 'bulletpoints')}
                                  </div>
                              </div>
                          </div>
                        )}

                        {activeOverallTab === 'previous_period_comparison' && (
                            <div className="flex gap-3">
                                <div className="border rounded-lg w-1/2">
                                    <div className="text-md p-3 bg-green-50 text-green-900 rounded-t-lg">Key Positive Points</div>
                                    <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                        {reportData?.overall?.previous_period_comparison?.positive_points && renderExplanations(reportData.overall.previous_period_comparison.positive_points, 'Agent Feedback', 'bulletpoints')}
                                    </div>
                                </div>
                                
                                <div className="border rounded-lg w-1/2">
                                    <div className="text-md p-3 bg-orange-50 text-orange-900 rounded-t-lg">Key Improvements</div>
                                    <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                        {reportData?.overall?.previous_period_comparison?.negative_points && renderExplanations(reportData.overall.previous_period_comparison.negative_points, 'Agent Feedback', 'bulletpoints')}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Agent Feedback Score */}
                <div className="border rounded-lg p-4 bg-white">
                    <h1 className="text-xl font-semibold text-gray-900 mb-2">Agent Feedback Score</h1>
                    <div className="space-y-2">
                        {Object.entries(reportData?.parameters || {}).map(([key, value]) => (
                            <div key={key} className="border rounded-lg">
                                <div className="flex justify-between items-center px-2 py-4 cursor-pointer" onClick={() => toggleSection(`param_${key}`)}>
                                    <div className="flex items-center space-x-4">
                                        {openSections[`param_${key}`] ? <MdExpandLess size={16} /> : <ChevronRight size={16} />}
                                        <h3 style={{fontSize: "15px"}} className='capitalize'>{key.replaceAll('_', ' ')}</h3>
                                    </div>
                                    <div className="flex items-center space-x-4">
                                        <span style={{fontSize: "15px"}} className='bg-indigo-50 text-indigo-600 px-3 py-1 rounded-md'>{value.ans}</span>
                                    </div>
                                </div>
                                {openSections[`param_${key}`] && (
                                    <div className="px-4 py-1" style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                                        <div>
                                            {value.explanation_with_source && renderExplanations(value.explanation_with_source, 'Agent Feedback', 'bulletpoints')}
                                        </div>
                                        {value.subparameters && renderSubparameters(value.subparameters, key)}
                                        <div className="flex gap-3">
                                          <div className="border rounded-lg w-1/2">
                                              <div className="text-md p-3 bg-green-50 text-green-900 rounded-t-lg">Key Positive Points</div>
                                              <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                                  {value?.positive_points && renderExplanations(value.positive_points, 'Agent Feedback', 'bulletpoints')}
                                              </div>
                                          </div>
                                          
                                          <div className="border rounded-lg w-1/2">
                                              <div className="text-md p-3 bg-orange-50 text-orange-900 rounded-t-lg">Key Improvements</div>
                                              <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                                  {value?.negative_points && renderExplanations(value.negative_points, 'Agent Feedback', 'bulletpoints')}
                                              </div>
                                          </div>
                                      </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Concerns & Queries */}
                <div className="border rounded-lg p-4 bg-white">
                    <h1 className="text-xl font-semibold text-gray-900 mb-2">Concerns & Queries</h1>
                    
                    {/* Tab Navigation */}
                    <div className="flex border-b mb-4">
                        <button
                            onClick={() => setActiveConcernsQueriesTab('concerns')}
                            className={`px-4 py-2 text-sm rounded-t-lg`} style={{borderBottom: (activeConcernsQueriesTab === 'concerns') ? "3.5px solid rgb(111, 111, 254)" : "2px solid transparent", color: (activeConcernsQueriesTab === 'concerns') ? "rgb(111, 111, 254)": "black", fontSize: "15px"}}
                        >
                            Concerns
                        </button>
                        <button
                            onClick={() => setActiveConcernsQueriesTab('queries')}
                            className={`px-4 py-2 text-sm rounded-t-lg`} style={{borderBottom: (activeConcernsQueriesTab === 'queries') ? "3.5px solid rgb(111, 111, 254)" : "2px solid transparent", color: (activeConcernsQueriesTab === 'queries') ? "rgb(111, 111, 254)": "black", fontSize: "15px"}}
                        >
                            Queries
                        </button>
                    </div>

                    {/* Tab Content */}
                    <div>
                        {activeConcernsQueriesTab === 'concerns' && (
                            <div className="space-y-4">
                                <div className="flex gap-3">
                                  {/* Key Positive Points */}
                                  <div className="border rounded-lg w-1/2">
                                      <div className="text-md p-3 bg-green-50 text-green-900 rounded-t-lg">Key Positive Points</div>
                                      <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                          {reportData?.concerns_and_queries?.concerns?.positive_points && renderExplanations(reportData.concerns_and_queries.concerns.positive_points, 'Concern & Queries', 'bulletpoints')}
                                      </div>
                                  </div>

                                  {/* Key Improvements */}
                                  <div className="border rounded-lg w-1/2">
                                      <div className="text-md p-3 bg-orange-50 text-orange-900 rounded-t-lg">Key Improvements</div>
                                      <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                          {reportData?.concerns_and_queries?.concerns?.negative_points && renderExplanations(reportData.concerns_and_queries.concerns.negative_points, 'Concern & Queries', 'bulletpoints')}
                                      </div>
                                  </div>
                                </div>

                                {/* Data Table */}
                                <div className="border rounded-lg overflow-auto" style={{height: "40vh"}}>
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead>
                                        <tr className="text-left bg-gray-50">
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider rounded-tl-lg">Category</th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Subcategory</th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" style={{textAlign: "center"}}>Total Concerns</th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" style={{textAlign: "center"}}>Handled Concerns</th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider rounded-tr-lg" style={{textAlign: "center"}}>Handled Percentage</th>
                                        </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                        {reportData?.concerns_and_queries?.concerns?.concerns_categories?.map((query, index) => (
                                            <tr key={index} className="hover:bg-gray-50">
                                            <td className="px-4 py-3 text-sm text-gray-900" style={{fontSize: "0.7rem"}}>{query['category']}</td>
                                            <td className="px-4 py-3 text-sm text-gray-900" style={{fontSize: "0.7rem"}}>{query['subcategory']}</td>
                                            <td className="px-4 py-3 text-sm text-gray-900" style={{fontSize: "0.7rem"}}>{query['total']}</td>
                                            <td className="px-4 py-3 text-sm text-gray-900 text-center" style={{fontSize: "0.7rem"}}>{query['handled']}</td>
                                            <td className="px-4 py-3">
                                                <div className="flex items-center justify-center">
                                                {getScoreBar(Math.round((parseInt(query['handled']) / parseInt(query['total'])) * 100, 0))}
                                                <span className="text-sm ml-2" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{Math.round((parseInt(query['handled']) / parseInt(query['total'])) * 100, 0)}%</span>
                                                </div>
                                            </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {activeConcernsQueriesTab === 'queries' && (
                            <div className="space-y-4">
                              <div className="flex gap-3">
                                {/* Key Positive Points */}
                                <div className="border rounded-lg w-1/2">
                                    <div className="text-md p-3 bg-green-50 text-green-900 rounded-t-lg">Key Positive Points</div>
                                    <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                        {reportData?.concerns_and_queries?.queries?.positive_points && renderExplanations(reportData.concerns_and_queries.queries.positive_points, 'Concern & Queries', 'bulletpoints')}
                                    </div>
                                </div>

                                {/* Key Improvements */}
                                <div className="border rounded-lg w-1/2">
                                    <div className="text-md p-3 bg-orange-50 text-orange-900 rounded-t-lg">Key Improvements</div>
                                    <div style={{overflow: "auto", height: "250px", padding: "10px"}}>
                                        {reportData?.concerns_and_queries?.queries?.negative_points && renderExplanations(reportData.concerns_and_queries.queries.negative_points, 'Concern & Queries', 'bulletpoints')}
                                    </div>
                                </div>
                              </div>
                                

                                {/* Data Table */}
                                <div className="border rounded-lg overflow-hidden">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead>
                                        <tr className="text-left bg-gray-50">
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider rounded-tl-lg">Category</th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider">Subcategory</th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" style={{textAlign: "center"}}>Total Queries</th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider" style={{textAlign: "center"}}>Handled Queries</th>
                                            <th className="px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider rounded-tr-lg" style={{textAlign: "center"}}>Handled Percentage</th>
                                        </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                        {reportData?.concerns_and_queries?.queries?.queries_categories?.map((query, index) => (
                                            <tr key={index} className="hover:bg-gray-50">
                                            <td className="px-4 py-3 text-sm text-gray-900" style={{fontSize: "0.7rem"}}>{query['category']}</td>
                                            <td className="px-4 py-3 text-sm text-gray-900" style={{fontSize: "0.7rem"}}>{query['subcategory']}</td>
                                            <td className="px-4 py-3 text-sm text-gray-900" style={{fontSize: "0.7rem"}}>{query['total']}</td>
                                            <td className="px-4 py-3 text-sm text-gray-900 text-center" style={{fontSize: "0.7rem"}}>{query['handled']}</td>
                                            <td className="px-4 py-3">
                                                <div className="flex items-center justify-center">
                                                {getScoreBar(Math.round((parseInt(query['handled']) / parseInt(query['total'])) * 100, 0))}
                                                <span className="text-sm ml-2" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{Math.round((parseInt(query['handled']) / parseInt(query['total'])) * 100, 0)}%</span>
                                                </div>
                                            </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Metrics */}
                <div className="border rounded-lg p-4 bg-white">
                    <h1 className="text-xl font-semibold text-gray-900 mb-2">Metrics</h1>
                    <div className="overflow-x-auto">
                        {reportData?.metrics && reportData?.metrics?.length > 0 ? (
                            <div className="border rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead>
                                    <tr className="text-left bg-gray-50">
                                        {
                                            Object.keys(reportData?.metrics[0]).map((col, idx) => {
                                                const isFirst = idx === 0;
                                                const isLast = idx === Object.keys(reportData?.metrics[0]).length - 1;
                                                return (
                                                    <th key={idx} scope="col" className={`px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider ${isFirst ? 'rounded-tl-lg' : ''} ${isLast ? 'rounded-tr-lg' : ''}`}>
                                                        {col}
                                                    </th>
                                                )
                                            })
                                        }
                                    </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                        {
                                            reportData?.metrics.map((conversation, index) => {
                                                return (
                                                    <tr key={`${index}-${conversation.id}`} className="hover:bg-gray-50">
                                                        {
                                                            Object.keys(reportData?.metrics[0]).map((col, idx)=> {
                                                                const colNorm = String(col || '').toLowerCase();
                                                                const value = conversation[col];
                                                                const numericValue = typeof value === 'number' ? value : parseInt(value, 10);
                                                                const isFatal = colNorm.includes('fatal');
                                                                const isNeedsRev = (colNorm.includes('needs') && colNorm.includes('review')) || colNorm.includes('needs_review');
                                                                const clickable = (isFatal || isNeedsRev) && !Number.isNaN(numericValue) && numericValue > 0;
                                                                const employeeOverride = index === 0 ? null : getEmployeeFromRow(conversation);
                                                                const handleClick = () => openRecordsForMetric(isFatal ? 'fatal' : 'needs_review', employeeOverride);
                                                                return (
                                                                    <td key={`${idx}-${index}`} className="px-3 py-2 whitespace-nowrap text-sm text-gray-600" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>
                                                                        <span
                                                                          onClick={clickable ? handleClick : undefined}
                                                                          style={{ cursor: clickable ? 'pointer' : 'default', color: clickable ? '#4f46e5' : undefined, textDecoration: clickable ? 'underline' : 'none' }}
                                                                        >
                                                                          {value && String(value).length > 100 ? String(value).substr(0, 100)+"..." : value}
                                                                        </span>
                                                                    </td>
                                                                )
                                                             })
                                                         }
                                                     </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <p>No metrics data available.</p>
                        )}
                    </div>
                </div>
              </div>
            )
          }
        </>
      ) :
       (
        <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
          <div className="loader"></div>
          <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
        </div>
      )}
      {
        showConversationModal && (
          <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
                        <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                        zIndex: "999999999"}}>
                            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={()=>{handleClose();}}><FaTimes style={{color: "slategray"}}/></div>
                            <div style={{overflow: "auto", height: "100%", borderRadius: "10px"}}>
          <CallDetails selectedOption={service_id} open_type={handleClose} callIdProp={conversationId} selectedClientId={client_id} selectedSegment={segmentId} selectedTab={selectedModule}/>
          </div>
          </div>
          </div>
        )
      }
      {showGenerateTrainingSessionModal && (
        <div style={{zIndex: "9999999999", position: "fixed", top: "0", left: "0", height: "100%", width: "100%", background: "rgba(0,0,0, 0.5)"}}>
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md relative">
          <div className="flex justify-between items-center p-4 pb-2">
            <h2 className="text-xl text-gray-700" style={{fontWeight: "550"}}>Are you sure?</h2>
            <button 
              onClick={() => {
                setShowGenerateTrainingSessionModal(false);
              }}
              className="text-gray-500 hover:text-gray-700"
            >
             <FaTimes style={{color: "slategray"}}/>
            </button>
          </div>
          
          <div className="p-6 pt-2">
            <p className="text-gray-500 text-sm">Training session for this report ID will be generated.</p>
          </div>
          
          <div className="flex justify-end gap-3 p-6 pt-0">
            <button
              onClick={() => {
                setShowGenerateTrainingSessionModal(false);
              }}
              className="px-6 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50" style={{height: "40px", borderRadius: "4px"}}
            >
              Cancel
            </button>
            <button onClick={() => {
                generateTrainingSession()
              }}
              className="px-6 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700" style={{height: "40px", borderRadius: "4px"}}
            >
              Generate
            </button>
          </div>
        </div>
      </div>
        </div>
      )}
      {showConversationRecordsModal && (
        <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
          <div style={{position: "fixed", left: "2%", top: "3.5%", width: "96%", height: "93%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", zIndex: "999999999"}}>
            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={()=>{setShowConversationRecordsModal(false); setRecordsSegment(null);}}><FaTimes style={{color: "slategray"}}/></div>
            <div style={{overflow: "auto", height: "100%", borderRadius: "10px"}}>
              <ConversationRecords serviceID={service_id} clientID={client_id} type={'modal-open'} segment={recordsSegment} />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default IndividualReport